import { useCallback } from "react";
import { pluralizeWithCount } from "@common/helpers/string";
import {
    buildTransactionRefLabel,
    TransactionReference,
} from "@common/schemas/transactionReference.schema";
import { useGlobalTransactionViewDrawer } from "@components/transactions/TransactionViewDrawer/useGlobalTransactionViewDrawer";

export function useTransactionReferenceDrawer() {
    const openGlobalDrawer = useGlobalTransactionViewDrawer();

    return useCallback(
        (references: TransactionReference[]) => {
            if (references.length === 0) {
                return;
            }
            const transactionIds = references.map((ref) => ref.transactionId);
            const headerLabel =
                references.length === 1
                    ? (references[0].label ??
                      buildTransactionRefLabel(references[0]))
                    : pluralizeWithCount("transaction", references.length);

            openGlobalDrawer(
                { transactionIds },
                {
                    headerAddon: headerLabel,
                    autoSelectFirst: references.length === 1,
                    initialSelectedTransactionId:
                        references.length === 1
                            ? references[0].transactionId
                            : undefined,
                },
            );
        },
        [openGlobalDrawer],
    );
}
